const templateUrl = require('./unsent-shipment-footer.html');

const app = angular.module('msi.shipments.unsentShipmentFooter', []);

app.component('ogUnsentShipmentFooter', {
  bindings: {
    shipment: '<ogFor'
  },
  controller: 'ShipmentController',
  templateUrl: templateUrl
});

module.exports = app.name;
